import React, { useState, useEffect } from "react";
import { addLead, resetLead } from "../../redux/actions-exporter";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { Link } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

import MainBtn from "../repeats/mainBtn/MainBtn";
import FormSuccess from "../repeats/formSuccess/FormSuccess";
import { getContent } from "../../redux/actions-exporter.js";
import "./Footer.css";
import bg from "../../assets/images/footer.jpg";

const LEAD_SOURCE = "יצירת קשר";

const Footer = ({ isContact }) => {
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const content = useSelector((state) => state.content);
  const contentData = content.list;
  useEffect(() => {
    if (!Object.keys(content).length) {
      dispatch(getContent());
    } else {
      let contacts = contentData
        .filter(
          (item) =>
            item.categories.length > 0 &&
            item.categories[0].title === "Contacts"
        )
        .map((item) => item);

      setPhone(
        contacts.filter((item) => item.title === "phone")[0]?.description
      );
      setEmail(
        contacts.filter((item) => item.title === "email")[0]?.description
      );
    }
  }, [content]);

  const mediaArr = [
    {
      header: "אי-מייל",
      par: email,
      icon: EmailIcon,
    },

    {
      header: "טלפון",
      par: phone,
      icon: PhoneIcon,
    },
    {
      header: "תמיכה",
      par: "להסברים נוספים",
      icon: SupportAgentIcon,
    },
  ];

  const dispatch = useDispatch();
  const [form, setForm] = useState({ source: LEAD_SOURCE });
  const addedLead = useSelector((state) => state.lead.addedLead);
  const [send, setSend] = useState(false);

  useEffect(() => {
    if (addedLead) {
      setSend(true);
      setForm({ source: LEAD_SOURCE });
      dispatch(resetLead());
    }
  }, [addedLead]); // eslint-disable-line

  return (
    <>
      {/* <div className="article">
        <h1 className="homeTitle">איך לארוז דירה</h1>
        <div className="articleDiv">
          <p>  לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית קולהע צופעט למרקוח איבן איף, ברומץ כלרשט מיחוצים. קלאצי סחטיר בלובק. תצטנפל בלינדו למרקל אס לכימפו, דול, צוט ומעיוט - לפתיעם ברשג - ולתיעם גדדיש. קוויז דומור ליאמום בלינך רוגצה. לפמעט מוסן מנת. נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן צש בליא, מנסוטו צמלח לביקו ננבי, צמוקו בלוקריה שיצמה ברורק. קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח. עמחליף קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח. עמחליף לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סת אלמנקום ניסי נון ניבאה. דס איאקוליס וולופטה דיאם. וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק. גולר מונפרר סוברט לורם שבצק יהול, לכנוץ בעריר גק ליץ, ושבעגט ליבם סולגק. בראיט ולחת צורק מונחף, בגורמי מגמש. תרבנך וסתעד לכנו סתשם השמה - לתכי מורגם בורק? לתיג ישבעס.
          </p>
          <p>      קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח. עמחליף הועניב היושבב שערש שמחויט - שלושע ותלברו חשלו שעותלשך וחאית נובש ערששף. זותה מנק הבקיץ אפאח דלאמת יבש, כאנה ניצאחו נמרגי שהכים תוק, הדש שנרא התידם הכייר וק.
          </p>
          <p>      נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן קוואזי במר מודוף. אודיפו בלאסטיק מונופץ קליר, בנפת נפקט למסון בלרק - וענוף הועניב היושבב שערש שמחויט - שלושע ותלברו חשלו שעותלשך וחאית נובש ערששף. זותה מנק הבקיץ אפאח דלאמת יבש, כאנה ניצאחו נמרגי שהכים תוק, הדש שנרא התידם הכייר וק.
          </p>
          <p>      סחטיר בלובק. תצטנפל בלינדו למרקל אס לכימפו, דול, צוט ומעיוט - לפתיעם ברשג - ולתיעם גדדיש. קוויז דומור ליאמום בלינך רוגצה. לפמעט מוסן מנת. להאמית קרהשק סכעיט דז מא, מנכם למטכין נשואי מנורך. לורם איפסום דולור סיט אמט,
          </p>
        </div>
      </div> */}
      {isContact && (
        <div className="contact">
          <h1 className="homeTitle">יצירת קשר</h1>
          <div className="contactDiv">
            {!send ? (
              <Form className="formBox">
                <Row className="mb-3 row">
                  <Form.Group
                    as={Col}
                    className="mb-3"
                    controlId="formBasicName-Contact"
                  >
                    <Form.Label className="fw-semibold mb-2">שם</Form.Label>
                    <Form.Control
                      onChange={(e) =>
                        setForm({ ...form, [e.target.name]: e.target.value })
                      }
                      name="firstName"
                      value={form.firstName}
                      type="text"
                      placeholder="השם שלי"
                    />
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    className="mb-3"
                    controlId="formBasicEmail-Contact"
                  >
                    <Form.Label
                      className="fw-semibold mb-2"
                      id="formBasicEmailLabel"
                    >
                      אי-מייל
                    </Form.Label>
                    <Form.Control
                      onChange={(e) =>
                        setForm({ ...form, [e.target.name]: e.target.value })
                      }
                      value={form.email}
                      name="email"
                      type="email"
                      placeholder="האימייל שלי"
                    />
                  </Form.Group>
                  {/* </Row>
              <Row className="mb-3 row"> */}

                  <Form.Group
                    as={Col}
                    className="mb-3"
                    controlId="formBasicPhone-Contact"
                  >
                    <Form.Label
                      className="fw-semibold mb-2"
                      id="formBasicPhoneLabel"
                    >
                      טלפון
                    </Form.Label>
                    <Form.Control
                      onChange={(e) =>
                        setForm({ ...form, [e.target.name]: e.target.value })
                      }
                      value={form.phone}
                      name="phone"
                      type="phone"
                      placeholder="הטלפון שלי"
                    />
                  </Form.Group>

                  {/* <Form.Group as={Col} className="mb-3" controlId="formBasicity">
                  <Form.Label className="fw-semibold mb-2">כתובת</Form.Label>
                  <Form.Control type="text" placeholder="הכתובת שלי" />
                </Form.Group> */}
                </Row>
                <Row className="mb-3 row">
                  <Form.Group className="mb-3 text" controlId="formBasicEmail">
                    <Form.Label
                      className="fw-semibold mb-2"
                      id="formBasicMessageLabel"
                    >
                      פנייה
                    </Form.Label>
                    <Form.Control
                      name="message"
                      value={form.message}
                      onChange={(e) =>
                        setForm({ ...form, [e.target.name]: e.target.value })
                      }
                      // as="textarea"
                      placeholder="הפנייה שלי"
                      style={{ height: "100px", width: "100%" }}
                    />
                  </Form.Group>
                </Row>
                <div className="contact-btnDiv row">
                  <MainBtn
                    text="יצירת קשר"
                    handleSend={() => dispatch(addLead(form))}
                  />
                </div>
              </Form>
            ) : (
              <FormSuccess
                text1="תודה שבחרת בנו!"
                text2="נציג יחזור אליך בהקדם"
              />
            )}
          </div>
        </div>
      )}
      <div className="mediaDiv">
        {mediaArr.map((el, i) => {
          return (
            <div className="media" key={i}>
              <div className="iconWrapper">
                <el.icon bg="grey" fontSize="large" color="warning" />
              </div>
              <h1>{el.header}</h1>
              <p>{el.par}</p>
            </div>
          );
        })}
      </div>

      <div className="foot">
        <img src={bg} alt="" loading="lazy" />
        <div className="content">
          <div className="right">
            <h5>הובלה ואחסנה</h5>
            <p>כל פתרונות ההובלה והאחסנה מרוכזים במקום אחד</p>
            <p>שירות בכל רחבי הארץ באמינות ודיוק ללא פשרות</p>
          </div>
          <div className="center">
            <h5>קישורים</h5>
            <Link to="">
              <p>אודות</p>
            </Link>
            <Link to="">
              <p>יצירת קשר</p>
            </Link>
          </div>
          <div className="left">
            <h5>עקבו אחרינו</h5>
            <div className="social">
              <FacebookIcon />
              <TwitterIcon />
              <InstagramIcon />
              <YouTubeIcon />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
